<template lang="pug">
.fileSpace
  el-button.freshBtn(v-if="noDelete && flowFileList.length" type="text" @click="refresh") 刷新轻量化状态
  el-table.fileView(v-if="flowFileList.length > 0" :data="flowFileList" :show-header="false" max-height="200px" border)
    el-table-column(label="名称" v-slot="{row}")
      .labelList
        fileLightFlag.lightShare(v-if="noDelete" :row="row" :form-flow="true" @updateLight="updateLight")
        img(:src="className(row)")
        .title(@click="preview(row)" :title="row.fileName") {{row.fileName}}
        span.path(v-if="row.pathName && (showBar||isRVT)") {{row.pathName}}
        el-link(v-if="row.pathName && (showBar||isRVT)" type="primary" @click.native="toProjectDoc(row.paths)") 跳转
    el-table-column(label="绑定" v-if="flowKey==='check'" v-slot="{row}")
      .table_class.approval_class(v-if="row.bindStatus===0") 未绑定
      .table_class.adopt_class(v-else-if="row.bindStatus===1") 绑定成功
      .table_class.reject_class(v-else) 绑定失败
    el-table-column(label="操作"  fixed="right" width="120px" v-slot="{row}")
      .midd-table
        img.midd-img(:src="proofread_png" v-if="flowKey==='check'" alt="校审" title="校审" @click="preview(row)")
        img.midd-img(:src="binding_png" v-if="showBinding && row.bindStatus === 0"  title="绑定" @click="binding(row)")
        img.midd-img(:src="binding_png" v-if="showBinding && row.bindStatus !== 0"  title="重新绑定" @click="binding(row)")
        i.el-icon-download(title="下载" @click="downLoadFile(row)" )
        i.el-icon-delete(title="删除" v-if="!noDelete" @click="deleteRow(row)")
</template>

<script>
import { tableRowIcon, filePreviewV1, common2D3DFileType } from "@/CommonDP/utils/docPublic";
import { downloadUrltoken, downloadFile } from "@/CommonDP/utils/index";
import { mapState } from "vuex";
import { approveParams, addStartAttachedFiles, deleteStartAttachedFiles } from "./index.js";
import flowService from "@/CommonDP/service/flow-service";
import docService from "@/CommonDP/service/doc-service";
import XtDesignService from "@/CommonDP/service/XtDesign-service";
import fileLightFlag from "@/CommonDP/components/fileLightFlag.vue";
export default {
  components: { fileLightFlag },
  props: {
    noDelete: {
      type: Boolean,
      default: false
    },
    flowKey: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      urlflowFileList: [],
      proofread_png: require("@/CommonDP/assets/approval/proofread.png"),
      binding_png: require("@/CommonDP/assets/approval/binding.png")
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      floderObj: state => state.uploaderLocal.floderObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    }),
    flowFileList() {
      return this.urlflowFileList.length > 0 ? this.urlflowFileList : approveParams.fileInfoList || [];
    },
    nodeList() {
      return approveParams.nodeList;
    },
    showBinding() {
      return this.nodeList.findIndex(e => e.nodeStatus === "2") === this.nodeList.length - 1 && this.flowKey === "check";
    },
    // cad跳转样式
    showBar() {
      return window.location.href.indexOf("jsName=BimEx") === -1;
    },
    // rvt跳转样式
    isRVT() {
      return window.location.href.indexOf("jsName=BimExRVT") === -1;
    },
    flowInstanceId() {
      return approveParams.detail.flowInstanceId;
    }
  },
  watch: {
    floderObj(newValue) {
      if (newValue.fileId) {
        // 本地上传改成1 uploader组件上传有问题
        if (newValue.uploadType === "4") {
          newValue.uploadType = 1;
        }
        addStartAttachedFiles([newValue]);
      }
    }
  },
  methods: {
    // 刷新轻量化状态
    refresh() {
      const noSuccessfileList = this.flowFileList.filter((item) => common2D3DFileType(item));
      noSuccessfileList.forEach(async ele => {
        const { data } = await XtDesignService.getFileDetails(ele.fileId);
        this.$set(ele, 'status', data.status);
      });
    },
    // 轻量化操作
    updateLight(row, type) {
      const prjId = this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.fileId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
            this.refresh();
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },
    // 接口：获取文件列表
    getFileList() {
      return this.flowFileList || [];
    },
    setFileList(fileList) {
      this.urlflowFileList = fileList || [];
      addStartAttachedFiles(this.urlflowFileList);
    },
    className(row) {
      return tableRowIcon(row);
    },
    preview(row) {
      const data = {
        fileType: row.fileType,
        fileId: row.fileId,
        versionId: row.versionIds || row.fileVersion,
        flowInstanceId: this.flowInstanceId,
        status: row.status,
        parentId: row.parentId
      };
      filePreviewV1(data, this.flowFileList);
    },
    // 跳转到项目文件，打开文件所在文件夹
    async toProjectDoc(paths) {
      const result = await flowService.getProjectUsers(this.prjInfo.prjId);
      const users = result.data || [];
      const exist = users.filter(item => item.userId === this.userInfo.userId);
      if (!exist || !exist.length) {
        this.$message.warning("当前用户不在该项目内");
        return;
      }
      const res = await flowService.viewList(this.prjInfo.prjId);
      this.$store.dispatch("updatePrj", res.data);
      this.$store.dispatch("XtDesignUpdateNav", paths);
      this.$router.push({
        path: "/project-XtDesign"
      });
    },
    downLoadFile(row) {
      const fileId = row.fileId;
      const url = downloadUrltoken("EnterpriseDoc", fileId);
      downloadFile(url);
    },
    // CAD端绑定操作
    async binding() {
      if (this.showBar) this.$message.warning("请前往cad端进行绑定操作");
    },
    deleteRow(row) {
      this.$confirm(`您确定取消${row.fileName}文件嘛`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        deleteStartAttachedFiles(row);
      }).catch((error) => {
        console.log(error);
      });
    }
  }

};
</script>

<style lang="scss" scoped>
.fileSpace{
  width: 100%;
  position: relative;

  .freshBtn{
    position: absolute;
    right: 16px;
    top: -32px;
  }
}
.fileView{
  margin-top: 10px;
}
.labelList{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 20px;
  .lightShare{
    position:absolute;
    left:0
  }
  img{
    width: 22px;
    height: 22px;
  }
  .title{
    margin-left: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  .path{
    margin-left: 50px
  }
  .el-link{
    margin-left: 15px;
  }
}
.table_class {
  width: 70px;
  font-size: 14px;
  border-radius: 15px;
  margin: 0 5px;
  text-align: center;
}
.approval_class {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
  text-align: center;
}
.adopt_class {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
  text-align: center;
}
.reject_class {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
  text-align: center;
}
.midd-table{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.midd-img {
  margin-right: 15px;
  display: block;
  color: var(--theme-color);
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.el-icon-download{
  font-size: 16px;
  color: var(--theme-color);
  cursor: pointer;
}
.el-icon-delete{
  margin-left: 5px;
  font-size: 16px;
  color: #f54f45;
  cursor: pointer;
}
</style>
